import { useEffect, useState } from 'react';
import { useGetDownloadNaechsterWerktagMutation } from '../../api/AuftragAPI';
import CalendarComponent from '../../component/CalendarComponent/CalendarComponent';
import { formatToEuroDate } from '../../util/DateUtils';

export default function LandingPageAussendienst() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    //const navigate = useNavigate();

    const [getDlMutation] = useGetDownloadNaechsterWerktagMutation();
    const [naechsterWerktag, setNaechsterWerktag] = useState<Date>(new Date());
    const [inEinerWoche, setInEinerWoche] = useState<Date>(new Date());


    const ermitteleNaechstenWerktag = () => {
        let naechsterTag = new Date();
        naechsterTag.setDate(naechsterTag.getDate() + 1);
        if (naechsterTag.getDay() === 6) { // Samstag
            naechsterTag.setDate(naechsterTag.getDate() + 2); // Montag
        } else if (naechsterTag.getDay() === 7) { // Sonntag
            naechsterTag.setDate(naechsterTag.getDate() + 1); // Montag
        }
        setNaechsterWerktag(naechsterTag);
    }

    const ermitteleInEinerWoche = () => {
        let inEinerWoche = new Date();
        inEinerWoche.setDate(inEinerWoche.getDate() + 7);
        /*if (naechsterTag.getDay() === 6) { // Samstag
            naechsterTag.setDate(naechsterTag.getDate() + 2); // Montag
        } else if (naechsterTag.getDay() === 7) { // Sonntag
            naechsterTag.setDate(naechsterTag.getDate() + 1); // Montag
        }*/
        setInEinerWoche(inEinerWoche);
    }


    useEffect(() => {
        ermitteleNaechstenWerktag();
        ermitteleInEinerWoche();
    }, []);

    const downloadFilesNextWorkday = async () => {
        const { blob, filename } = await getDlMutation({ datum: naechsterWerktag }).unwrap();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    return (
        <>
            <div className="container">

                <h3>Aussendienst</h3>

                <button className="btn btn-primary" onClick={downloadFilesNextWorkday}><i className="bi bi-download"></i> Download Dateien für {formatToEuroDate(naechsterWerktag)}</button>
                <button className="btn btn-secondary" onClick={downloadFilesNextWorkday}><i className="bi bi-download"></i> Download Dateien für {formatToEuroDate(inEinerWoche)} (Sicherung)</button>

                <br />

                <CalendarComponent />
            </div>

        </>
    );
}
